/**
 * Active-state matchers for navigation items.
 *
 * @module MatchNav
 */

import { isReportAgentPath } from "@/constants/agents"

/** Matches any route under the given prefix. */
export const startsWith = (prefix: string) => (pathname: string) =>
  pathname.startsWith(prefix)

/**
 * The Reports nav item stays active on both /ui/reports and report-surfaced
 * agent routes (AEO, SEO Audit) under /ui/agent/*. Shared by the main and guest
 * menus so the two never drift.
 */
export const reportsMatcher = (pathname: string) =>
  pathname.startsWith("/ui/reports") || isReportAgentPath(pathname)
